import { render } from "./GridTableLeaf.vue?vue&type=template&id=64fbec6d"
import script from "./GridTableLeaf.vue?vue&type=script&lang=js"
export * from "./GridTableLeaf.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__